import { Component, OnInit } from '@angular/core';
import {InvoiceTemplateBase} from '../invoce-template-base';

@Component({
  selector: 'eci-monthly-subscription-payment-invoice-form',
  templateUrl: './monthly-subscription-payment-invoice-form.component.html',
  styleUrls: ['./monthly-subscription-payment-invoice-form.component.scss']
})
export class MonthlySubscriptionPaymentInvoiceFormComponent extends InvoiceTemplateBase implements OnInit {

  ngOnInit(): void {
      this.model = {
          ...this.template,
          ...this.invoice,
          customerCompany: {
              ...this.template.customerCompany,
              ...this.invoice.customerCompany
          }
      };

      if (!this.model.labels.cocNr) {
          this.model.labels['cocNr'] = 'COC NR:'
      }

  }

}
